export { default as Tabs } from './Tabs';
export { default as Tab } from './Tab';
export { default as List } from './TabList';
export { default as Link } from './TabLink';


// WEBPACK FOOTER //
// ./src/components/Tabs/index.ts